import type { CmsContentAboutServicesForm } from "@/modules/cms/domain/contracts";
import { slugify } from "@/shared/lib/slugify";
import { nanoid } from "nanoid";

function slugFromTitle(title?: { en?: string; lo?: string; th?: string }): string {
  const raw = title?.en?.trim() || title?.lo?.trim() || title?.th?.trim() || "";
  const base = slugify(raw);
  return base || `item-${nanoid(6)}`;
}

function normalizeLinkMode(
  mode: string | undefined,
): CmsContentAboutServicesForm["items"][number]["linkMode"] {
  if (mode === "showcase" || mode === "product") return mode;
  if (mode === "catalog" || mode === "item") return "showcase";
  return "none";
}

function defaultShowcaseKind(
  slug: string,
  linkMode: CmsContentAboutServicesForm["items"][number]["linkMode"],
): CmsContentAboutServicesForm["items"][number]["showcaseKind"] | undefined {
  if (linkMode !== "showcase") return undefined;
  if (slug === "quality-products") return "online-showcase";
  return "production";
}

export function normalizeAboutServicesContent(
  content: Partial<CmsContentAboutServicesForm> | null | undefined,
): CmsContentAboutServicesForm {
  const items = (content?.items ?? []).map((item, i) => {
    const title = item.title ?? {};
    const linkMode = normalizeLinkMode(item.linkMode);
    const slug = item.slug?.trim() || slugFromTitle(title);
    const stockServiceCode = item.stockServiceCode?.trim() || null;
    const showStockPrice = stockServiceCode
      ? item.showStockPrice !== false
      : false;

    return {
      id: item.id?.trim() || nanoid(),
      slug,
      imageKey: item.imageKey ?? "",
      title,
      content: item.content ?? {},
      intro: item.intro ?? undefined,
      linkMode,
      showcaseKind:
        linkMode === "showcase"
          ? (item.showcaseKind ?? defaultShowcaseKind(slug, linkMode))
          : undefined,
      productIds: [],
      stockServiceCode,
      showStockPrice,
      isActive: item.isActive ?? true,
      order: item.order ?? i,
    };
  });

  return {
    isActive: content?.isActive ?? true,
    items,
  };
}
